import {
  createRouter,
  createWebHistory
} from 'vue-router'
import Layout from '../views/layout/Layout'
import lang from '../lang'

const routerHistory = createWebHistory()

export const constantRouterMap = [{
    path: '/',
    redirect: '/home',
    hidden: true
  },
  {
    path: '/home',
    component: Layout,
    children: [{
      path: '/home',
      component: () => import('../views/home/Home'),
      meta: {
        title: lang.get('首頁')
      }
    }],
    meta: {
      title: lang.get('首頁')
    }
  },
  {
    path: '/customerservice',
    component: Layout,
    children: [{
        path: '/customerservice',
        redirect: '/customerservice/terms',
        hidden: true
      },
      {
        path: '/customerservice/terms',
        component: () => import('../views/customerservice/Terms'),
        meta: {
          title: lang.get('會員條款')
        }
      },
    ],
    meta: {
      title: lang.get('會員條款')
    }
},
  {
    path: '/404',
    component: Layout,
    children: [{
      path: '/404',
      component: () => import('../views/notfound/NotFound'),
      meta: {
        title: '404'
      }
    }],
    hidden: true,
    meta: {
      title: '404'
    }
  },
  {
    path: '/:path(.+)',
    redirect: '/404',
    hidden: true
  },
]

const router = createRouter({
  history: routerHistory,
  scrollBehavior: () => ({
    y: 0
  }),
  routes: constantRouterMap
})

router.beforeEach((to, from, next) => {
  if (to.meta && to.meta.title) {
    window.document.title = `${lang.get('The Finder：追尋者')} - ${to.meta.title}`
  } else {
    window.document.title = lang.get('The Finder：追尋者')
  }
  if (from.query.utm_source && !to.query.utm_source) {
    let schar = '?'
    if (to.query)
      schar = '&'
    to.params.utm_source = from.params.utm_source
    to.query.utm_source = from.query.utm_source
    to.fullPath = to.fullPath + schar + 'utm_source=' + from.query.utm_source
    to.href = to.href + schar + 'utm_source=' + from.query.utm_source
  }
  if (from.query.recommend && !to.query.recommend) {
    let schar = '?'
    if (to.query)
      schar = '&'
    to.params.recommend = from.params.recommend
    to.query.recommend = from.query.recommend
    to.fullPath = to.fullPath + schar + 'recommend=' + from.query.recommend
    to.href = to.href + schar + 'recommend=' + from.query.recommend
  }
  next()
})

router.lang = lang

export default router